import { TemplateList } from "./List";
import { EditForm } from "./EditForm";

export default {
  List: TemplateList,
  EditForm,
};
